import { SxProps } from "@mui/material";

export const RADIUS = "6px";

export const BLUE_500 = "#0055A4";
export const GRAY_200 = "#E4E7EC";
export const GRAY_400 = "#98A2B3";
export const GRAY_500 = "#667085";
export const GRAY_600 = "#475467";
export const GRAY_800 = "#1D2939";

export const areaLabelSx = {
  color: BLUE_500,
  fontFamily: "Manrope",
  fontSize: "22px",
  lineHeight: "28px",
  fontWeight: 600,
};

export const headingSx: SxProps = {
  color: GRAY_800,
  fontFamily: "Manrope",
  fontSize: "24px",
  lineHeight: "32px",
  fontWeight: 800,
};

export const subheadingSx: SxProps = {
  color: GRAY_500,
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
};

export const questionLabelSx: SxProps = {
  color: "#0055A4",
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "20px",
  fontWeight: 600,
  mb: 1,
};

export const optionTextSx = (): SxProps => ({
  color: "#465869",
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
});

import { commonStyles } from "../../tokens";
export const cardBoxSx = commonStyles.stepCard;
